__turbopack_context__.v({
  "darkBackground": "Tabs-module-scss-module__sdMneG__darkBackground",
  "fullWidhtMobile": "Tabs-module-scss-module__sdMneG__fullWidhtMobile",
  "fullWidth": "Tabs-module-scss-module__sdMneG__fullWidth",
  "grayBackground": "Tabs-module-scss-module__sdMneG__grayBackground",
  "lightBackground": "Tabs-module-scss-module__sdMneG__lightBackground",
  "selected": "Tabs-module-scss-module__sdMneG__selected",
  "selectedTitle": "Tabs-module-scss-module__sdMneG__selectedTitle",
  "tabButton": "Tabs-module-scss-module__sdMneG__tabButton",
  "tabTitle": "Tabs-module-scss-module__sdMneG__tabTitle",
  "tabs": "Tabs-module-scss-module__sdMneG__tabs",
});
